module.exports = __webpack_public_path__ + "img/map-location-dot.c6008595.svg";